<template>
  <div class="iv-bg-w iv-main-width  iv-m-t-16" :style="{paddingTop: isFirst ? '10px' : '0'}">
    <div class="iv-list-guide">
      <div class="iv-list-right no-menu">
<!--        <right-views ref="rightViewRef" :type="righttype" :id="rightId" @onloaded="onloaded"></right-views>-->
        <Tabs value="list">
          <Tab-pane label="列表" name="list">
            <rightList ref="rightList" :title="title" @onloaded="onloaded"></rightList>
          </Tab-pane>
<!--          <Tab-pane label="图片" name="pic">-->
<!--            <rightPic :title="title" @onloaded="onloaded"></rightPic>-->
<!--          </Tab-pane>-->
        </Tabs>
      </div>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <!-- <router-view /> -->
  </div>
</template>

<script>
// import rightViews from './model/dj-all.vue'
import rightList from './model/dj-study.vue'
import rightPic from './model/dj-picture.vue'

export default {
  data() {
    return {
      menuList: [],
      theme2: 'light',
      spinShow: true,
      isFirst: true,
      title: this.$route.query.keyword,
      resultData:[],
    }
  },
  created() {
    // this.name = this.$route.query.categoryName
    // this.initTabs()
  },
  watch: {
    '$route'(val) {
      console.log('searchpage>>>>',val)
      console.log('keyword>>>>',this.$route.query.keyword)
      this.title = this.$route.query.keyword
      this.$refs.rightList.initTabs(this.$route.query.keyword)
      // this.initTabs()
      /*if (val.name != 'newsDetail') {
        this.name = val.meta.title
        this.initTabs()
      }
      this.categoryType = val.query.categoryType
      if (val.query.categoryId) {
        this.$refs.rightViewRef.initTabs(val.query.categoryId,0)
      }*/
    }
  },
  methods: {
    onloaded() {
      this.spinShow = false
    },

    initTabs() {//查询栏目下二级栏目
      this.spinShow = true
      this.menuList = []
      this.$ajax({
        url: 'api-qixuan/cms/front/getBlogList',
        method: 'get',
        data: {
          title: this.$route.query.keyword,
          pageNum: 1,
          pageSize: 10,
        }
      }).then(({data}) => {
        this.resultData = data.rows
        this.spinShow = false

      })
    }
  },
  components: {
    rightList,
    rightPic
  }
}
</script>

<style lang="scss" scoped>
.iv-bg-w {
  background-color: white;
  height: 100%;
  position: relative;

  .hr {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 1px;
    left: 271px;
    background: rgba(0, 0, 0, 0.15);
  }
}

.iv-list-guide {
  margin: 0 auto;
  width: 1200px;
  z-index: 0;
  background: #FFFFFF;

  .iv-list-left {
    float: left;
    width: 272px;

    /deep/ .ivu-row {
      width: 272px !important;

      .ivu-menu {
        z-index: 0;
        width: 272px !important;

        .ivu-menu-item {
          width: 271px !important;
          font-size: 16px;
          // color: rgba(0, 0, 0, 0.64);
          font-weight: bold;
          // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
        }

        .ivu-menu-submenu-title {
          width: 271px !important;
          font-size: 16px;
          // color: rgba(0, 0, 0, 0.64);
          font-weight: bold;
          // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
        }
      }

      .ivu-menu-item[class~=ivu-menu-item].ivu-menu-item-active[class~=ivu-menu-item-active] {
        // width: 1px;
        // height: 56px;
        // background: #2373C8;
        font-size: 16px;
        // color: rgba(0, 0, 0, 0.64);
        font-weight: bold;
        border-right: 2px solid rgba(104, 171, 243, 0.6);
        // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
        background: #F0FAFF;
      }

      .ivu-menu-item[class~=ivu-menu-item]:hover {
        background: #F0FAFF !important;
      }

      .ivu-menu-item[class~=ivu-menu-item].ivu-menu-item-active[class~=ivu-menu-item-active] {
        background: #F0FAFF !important;
      }
    }
  }

  .iv-list-right {
    // float: right;
    margin-left: 296px;
    width: 904px;
    padding-right: 24px;

    &.no-menu {
      width: 1200px;
      margin-left: 0;
      padding-left: 24px;

      /deep/ .iv-list-right-cont {
        div {
          margin-right: 34px;

          &:nth-of-type(4n) {
            margin-right: 0px;
          }
        }
      }
    }

    // .iv-list-right-title {
    //   height: 57px;
    //   font-size: 16px;
    //   color: #000000;
    //   line-height: 57px;
    //   border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    //   span {
    //     display: inline-block;
    //     height: 57px;
    //     line-height: 57px;
    //     border-bottom: 1px solid #2373C8;;
    //   }
    // }
  }

  /deep/ .iv-list-page {
    float: right;
    margin-top: 20px;
    padding-bottom: 28px;
  }
}
</style>